/*  A Vuex module. 
*   Userstore to store common userdata for current user and further
*/
const state = {
    newOrders : [],
    updatedOrders : [],
    updatedPaymentVerificationState : [],
};

const mutations = {
    newOrders: (state, val) => {
        state.newOrders = val;
    },
    updatedOrders: (state, val) => {
        state.updatedOrders = val;
    },
    updatedPaymentVerificationState: (state, val) => {
        state.updatedPaymentVerificationState = val;
    },
};

const actions = {
    newOrders: ({ commit }, val) => {
        commit("newOrders", val);
    },
    updatedOrders: ({ commit }, val) => {
        commit("updatedOrders", val);
    },
    updatedPaymentVerificationState: (state, val) => {
        commit("updatedPaymentVerificationState", val);
    },
};

const getters = {
    newOrders: (state) => {
        return state.newOrders;
    },
    updatedOrders: (state) => {
        return state.updatedOrders;
    },
    updatedPaymentVerificationState: (state, val) => {
        return state.updatedPaymentVerificationState;
    },
    state: (state) => {
        return {
            newOrders: state.newOrders,
            updatedOrders: state.updatedOrders,
            updatedPaymentVerificationState: state.updatedPaymentVerificationState,
        };
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};